import _ from 'lodash';

const initialState = {
    fetching: false,
    success: null,
    payload: []
};

const updateFile = (files, idToUpdate, update) => {
    return files.map((file) => {
        if (file.id === idToUpdate) {
            return {
                ...file,
                ...update
            };
        }

        return file;
    });
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'REJECT_FILE':
            return {
                ...state,
                payload: [
                    ...state.payload,
                    _.merge({}, action.payload.file, {
                        isUploading: false,
                        isFailed: true,
                        error: action.payload.errorMessage
                    })
                ]
            };
        case 'START_FILE_UPLOAD':
            return {
                ...state,
                payload: [
                    ...state.payload,
                    _.merge({}, action.file, {
                        isUploading: true
                    })
                ]
            };
        case 'FILE_UPLOAD_FAILED':
            return {
                ...state,
                payload: updateFile(state.payload, action.error.id, {
                    isUploading: false,
                    isFailed: true,
                    error: action.error.message
                })
            };
        case 'FILE_UPLOAD_SUCCESS':
            return {
                ...state,
                payload: updateFile(state.payload, action.id, {
                    isUploading: false,
                    isFailed: false,
                    error: null
                })
            };
        case 'REMOVE_FILE':
            return {
                ...state,
                payload: state.payload.filter((file) => file.id !== action.id)
            };
        case 'CLEANUP_UPLOADED_FILES':
            /**
             * Removes successfully uploaded files to prevent conflict with a status endpoint
             * and displaying duplicates, required for the case when filed has been uploaded an modal closed, and a call being made to DR status endpoint
             * which returns uploaded files
             */
            return {
                ...state,
                payload: state.payload.filter(
                    (file) => file.isUploading || file.isFailed
                )
            };
        default:
            return state;
    }
}
